export default __webpack_public_path__ + "static/media/img444.84b9e98a.png";